<div class="card">
  <div class="page-section counters" [style.background]="backgroundStyle">
    <div class="page-section-content d-flex jc-center ai-center">
      <div class="basis-90 basis-100--xs">
        <div class="d-flex flex-wrap flex-1 jc-center ai-center">
          <div class="stat d-flex fd-row" *ngFor="let column of tileInstance.iconColumns">
            <ng-container
              *ngIf="column.iconPosition === 'start'"
              [ngTemplateOutlet]="icon"
              [ngTemplateOutletContext]="{ column: column }"
            >
            </ng-container>

            <div class="content-container d-flex fd-col">
              <span
                [style.color]="column.headingFontColor"
                [style.fontSize]="column.headingFontSize | pxSuffix"
                [style.textAlign]="column.iconPosition === 'start' ? 'left' : 'right'"
              >
                {{ column.heading }}
              </span>
              <span
                [style.color]="column.textFontColor"
                [style.fontSize]="column.textFontSize | pxSuffix"
                [style.textAlign]="column.iconPosition === 'start' ? 'left' : 'right'"
              >
                {{ column.text }}
              </span>
            </div>

            <ng-container
              *ngIf="column.iconPosition === 'end'"
              [ngTemplateOutlet]="icon"
              [ngTemplateOutletContext]="{ column: column }"
            >
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #icon let-column="column">
  <div class="icon-container d-flex fd-col">
    <span class="material-icons border-circle lrg-icon icon-color-secondary">
      {{ column.icon }}
    </span>
  </div>
</ng-template>
